import React, { useRef, useState } from "react";

import { toast } from "react-toastify";
import ArrowDown from "../../assets/icons/ArrowDown";
import styles from "./Select.module.scss";

export default function Select({
  title,
  containerStyle,
  selectStyle,
  dataSelect,
  selectObserver,
  settings,
  labelStyle,
  assistants,
  activeBot,
  nameSelectedOption,
  activeTg,
  activeWa,
  activeInst,
  messenger,
}) {
  const [visibleOptions, setVisibleOptions] = useState(false);
  const [nameSelect, setNameSelect] = useState(nameSelectedOption || "");
  const selectRef = useRef(null);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setVisibleOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      setVisibleOptions(false);
    };
  }, []);

  React.useEffect(() => {
    if (settings) {
      dataSelect?.forEach((el) => {
        if (el.id === settings?.modelId) {
          setNameSelect(el.name);
        }
      });
    }
  }, [settings, dataSelect]);

  React.useEffect(() => {
    setNameSelect(nameSelectedOption);
  }, [nameSelectedOption]);

  React.useEffect(() => {
    if (assistants && !activeBot) {
      return setNameSelect(assistants[0]?.name);
    }
  }, [assistants, activeBot]);

  React.useEffect(() => {
    if (activeBot) {
      assistants.forEach((assistant) => {
        if (assistant.id === activeBot.assistantId) {
          setNameSelect(assistant.name);
        }
      });
    }
  }, [activeBot, assistants]);

  const handlerChangeName = (e) => {
    setNameSelect(e.target.label);
    selectObserver(e.target.value, e.target.label);
  };

  const showToastError = () => {
    toast.error("Вы не можете редактировать неактивную интеграцию", {
      toastId: "errorDeactivateTg",
    });
  };

  const handlerVisibleOptions = () => setVisibleOptions(!visibleOptions);
  return (
    <div className={`${styles.container} ${containerStyle}`} ref={selectRef}>
      <label className={`${styles.label} ${labelStyle}`}>{title}</label>
      <div
        className={`${styles.select} ${selectStyle}`}
        onClick={() => {
          if (
            (messenger === "telegram" && !activeTg) ||
            (messenger === "whatsapp" && !activeWa) ||
            (messenger === "instagram" && !activeInst)
          ) {
            showToastError();
          } else {
            handlerVisibleOptions();
          }
        }}
      >
        <ArrowDown className={!visibleOptions ? styles.arrow : styles.active} />
        <p className={`${styles.value}`}>{nameSelect}</p>
        {visibleOptions && (
          <div className={`${styles.options}`}>
            {dataSelect &&
              dataSelect.map((el, index) => {
                // if (el.name === nameSelect) return null;
                return (
                  <option
                    className={`${styles.option}`}
                    value={el.id}
                    onClick={handlerChangeName}
                    key={index}
                  >
                    {el.name || el}
                  </option>
                );
              })}
            {assistants &&
              assistants.map((assistant, index) => {
                if (assistant.name === nameSelect) return null;
                return (
                  <option
                    className={`${styles.option}`}
                    value={assistant.id}
                    onClick={handlerChangeName}
                    key={index}
                  >
                    {assistant.name}
                  </option>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
}
